/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * Samlla
 * Samlla Backend API
 * OpenAPI spec version: 0.1.0
 */
import { createQuery } from '@tanstack/svelte-query';
import type {
	CreateQueryOptions,
	CreateQueryResult,
	DataTag,
	QueryClient,
	QueryFunction,
	QueryKey
} from '@tanstack/svelte-query';

import type {
	GetSuggestionsApiSuggestionsGetParams,
	HTTPValidationError,
	SuggestionsResponse
} from '.././schemas';

import { customInstance } from '../../orval/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Return Smart Quick Add suggestions for the given date.

Scoring:
- BASE SCORE: entry frequency in last 30 days
- DAY-OF-WEEK BOOST: same weekday history (8 weeks) × 2
- RECENCY BOOST: entries in last 3 days × 1.5

Falls back to user favorites when no history is present.
 * @summary Get Suggestions
 */
export const getSuggestionsApiSuggestionsGet = (
	params?: GetSuggestionsApiSuggestionsGetParams,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<SuggestionsResponse>(
		{ url: `/api/suggestions`, method: 'GET', params, signal },
		options
	);
};

export const getGetSuggestionsApiSuggestionsGetQueryKey = (
	params?: GetSuggestionsApiSuggestionsGetParams
) => {
	return [`/api/suggestions`, ...(params ? [params] : [])] as const;
};

export const getGetSuggestionsApiSuggestionsGetQueryOptions = <
	TData = Awaited<ReturnType<typeof getSuggestionsApiSuggestionsGet>>,
	TError = HTTPValidationError
>(
	params?: GetSuggestionsApiSuggestionsGetParams,
	options?: {
		query?: Partial<
			CreateQueryOptions<Awaited<ReturnType<typeof getSuggestionsApiSuggestionsGet>>, TError, TData>
		>;
		request?: SecondParameter<typeof customInstance>;
	}
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetSuggestionsApiSuggestionsGetQueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuggestionsApiSuggestionsGet>>> = ({
		signal
	}) => getSuggestionsApiSuggestionsGet(params, requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as CreateQueryOptions<
		Awaited<ReturnType<typeof getSuggestionsApiSuggestionsGet>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSuggestionsApiSuggestionsGetQueryResult = NonNullable<
	Awaited<ReturnType<typeof getSuggestionsApiSuggestionsGet>>
>;
export type GetSuggestionsApiSuggestionsGetQueryError = HTTPValidationError;

/**
 * @summary Get Suggestions
 */

export function createGetSuggestionsApiSuggestionsGet<
	TData = Awaited<ReturnType<typeof getSuggestionsApiSuggestionsGet>>,
	TError = HTTPValidationError
>(
	params?: GetSuggestionsApiSuggestionsGetParams,
	options?: {
		query?: Partial<
			CreateQueryOptions<Awaited<ReturnType<typeof getSuggestionsApiSuggestionsGet>>, TError, TData>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetSuggestionsApiSuggestionsGetQueryOptions(params, options);

	const query = createQuery(() => ({ ...queryOptions, queryClient })) as CreateQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	query.queryKey = queryOptions.queryKey;

	return query;
}
